import {Tag} from "antd";

/** Định dạng số kiểu vi-VN. */
export const fmt = (n) => Number(n || 0).toLocaleString('vi-VN');

/** Link URL rút gọn (ellipsis + mở tab mới). */
export function UrlLink({url, text}) {
	if (!url) return <span style={{color: '#9ca3af'}}>—</span>;
	return (
		<a href={url} target="_blank" rel="noreferrer" title={url}
			style={{color: '#4f46e5', wordBreak: 'break-all'}}>
			{text || url}
		</a>
	);
}

/** Thẻ mã trạng thái HTTP, màu theo nhóm. */
export function StatusTag({status}) {
	const s = Number(status || 0);
	if (!s) return <Tag>—</Tag>;
	const color = s >= 500 ? 'red' : s >= 400 ? 'volcano' : s >= 300 ? 'gold' : 'green';
	return <Tag color={color}>{s}</Tag>;
}
